import { useState } from 'react';

import { useRouter } from 'next/router';

import { colors } from 'src/styles/colors';
import {
  CountryCode,
  refSubExitNudgeImage,
  subscriptionExitNudge
} from 'src/utils/constants/stringConstants';
import { FeatureFlagConstants } from 'src/utils/constants/utilConstants';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';
import { navigationHandler } from 'src/utils/UtilityMethods';

import { useAppStore } from 'src/hooks/useAppStore';
import Button from '../buttons/Button';
import Share from '../MetaButtons/Share/Share';
import Modal from '../modal/Modal';
import * as styles from './ReferralSubscriptionNudgeStyles';

interface ReferralSubscriptionNudgeProps {
  link: string;
  element: string;
}

const ReferralSubscriptionNudge: React.FC<ReferralSubscriptionNudgeProps> = ({
  link,
  element
}) => {
  const { usersLocationData, translations, remoteConfig, setPopups } =
    useAppStore();

  const router = useRouter();
  const [inviteClick, setInviteClick] = useState(false);
  const country = usersLocationData?.country_code || CountryCode.IN;
  const NEW_SUBSCRIPTION_STRINGS = translations.subscription;
  const { payload } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.CONFIG_REFERRAL
  );
  const offerPercentage =
    country.toLocaleLowerCase() === 'in'
      ? payload?.['REFERRAL_OFFER']
      : payload?.['REFERRAL_OFFER_GB'];

  const handleReferNowClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setInviteClick(true);
  };

  const onClosePopup = () => {
    setInviteClick(false);
  };

  const closeNudge = () => {
    setPopups({
      showReferralSubscriptionNudge: false,
      referralRedirectLink: '',
      referralSourceElement: ''
    });
    if (element === 'Back_Button') {
      router.back();
    } else {
      navigationHandler(link, element);
    }
  };

  const continuFlow = (event: React.MouseEvent<HTMLSpanElement>) => {
    if (event) {
      event.preventDefault();
    }

    setPopups({
      showReferralSubscriptionNudge: false,
      referralRedirectLink: '',
      referralSourceElement: ''
    });
    if (element === 'Back_Button') {
      router.back();
    } else {
      navigationHandler(link, element, event);
    }
  };

  const shareProps = {
    isReferral: true,
    isSportsLiveEvent: false,
    fromCarousel: false,
    onClosePopup,
    cssClassName: 'referralExitNudge'
  };

  return (
    <Modal
      show={true}
      onClose={closeNudge}
      width="336px"
      height="647px"
      background="linear-gradient(180deg, rgba(167, 133, 255, 0.20) 0%, rgba(167, 133, 255, 0.00) 100%), #0F0717"
      // isLoading={loadingSpinner}
      renderCloseIcon={true}
      closeIconColor={colors.white}
      padding="30px"
      cssClassName="referralExitNudge">
      <div css={styles.ReferralSubscriptionNudge}>
        <div css={styles.section}>
          <img
            css={styles.refImage}
            src={refSubExitNudgeImage}
            alt={subscriptionExitNudge}
          />
          <div css={styles.refTitleWrapper}>
            <h2 css={styles.title}>
              {NEW_SUBSCRIPTION_STRINGS?.Referral_SubExitNudge_Title_Text?.replace(
                '{{offer_precentage}}',
                offerPercentage
              )}
            </h2>
            <span css={styles.subTitle}>
              {NEW_SUBSCRIPTION_STRINGS.Referral_SubExitNudge_SubTitle_Text}
            </span>
          </div>
        </div>
        <div css={styles.section}>
          <div css={styles.howItWorks}>
            <span css={styles.howItWorkstitle}>
              {NEW_SUBSCRIPTION_STRINGS.Referral_SubExitNudge_Header_Text}
            </span>
            <div css={styles.howItWorksDesc}>
              <div css={styles.counterWrapper}>
                <span css={styles.counter}>1</span>
                <span css={styles.counterText}>
                  {NEW_SUBSCRIPTION_STRINGS.Referral_SubExitNudge_Point1_Text}
                </span>
              </div>
              <div css={styles.counterWrapper}>
                <span css={styles.counter}>2</span>
                <span css={styles.counterText}>
                  {NEW_SUBSCRIPTION_STRINGS?.Referral_SubExitNudge_Point2_Text?.replace(
                    '{{offer_precentage}}',
                    offerPercentage
                  )}
                </span>
              </div>
              <div css={styles.counterWrapper}>
                <span css={styles.counter}>3</span>
                <span css={styles.counterText}>
                  {NEW_SUBSCRIPTION_STRINGS?.Referral_SubExitNudge_Point3_Text?.replace(
                    '{{offer_precentage}}',
                    offerPercentage
                  )}
                </span>
              </div>
            </div>
          </div>
          <div css={styles.buttonWrapper}>
            {inviteClick ? <Share {...shareProps} /> : null}
            <Button callback={handleReferNowClick} customStyles={styles.btn}>
              {
                NEW_SUBSCRIPTION_STRINGS.Referral_ConsumptionBellyBanner_ReferNow_CTA
              }
            </Button>
            <div css={styles.btnContainer}>
              <span onClick={(e) => continuFlow(e)} css={styles.mayBelaterBtn}>
                {NEW_SUBSCRIPTION_STRINGS.Referral_SubExit_Nudge_CTA}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReferralSubscriptionNudge;
